import { Outlet, NavLink } from "react-router-dom";
import { LayoutDashboard, Users, GitFork, PhoneCall, MessageSquare, Bot, Settings, LogOut, Menu, UserCheck, Calendar } from "lucide-react";
import { useAuth } from "../lib/AuthContext";
import { useState } from "react";
import "../crm.css";

const navItems = [
  { label: "Dashboard", icon: LayoutDashboard, path: "/" },
  { label: "Leads", icon: Users, path: "/leads" },
  { label: "Pipeline", icon: GitFork, path: "/pipeline" },
  { label: "Calendar", icon: Calendar, path: "/calendar" },
  { label: "Calls", icon: PhoneCall, path: "/calls" },
  { label: "Messages", icon: MessageSquare, path: "/messages" },
  { label: "Team", icon: UserCheck, path: "/team" },
  { label: "AI Agent", icon: Bot, path: "/ai-agent" },
  { label: "Settings", icon: Settings, path: "/settings" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <div className="crm-shell">
      <div className={`crm-mobile-overlay ${open ? "visible" : ""}`} onClick={() => setOpen(false)} />

      <aside className={`crm-sidebar ${open ? "open" : ""}`}>
        <div className="crm-sidebar-logo">
          <img src="/Logo.png" alt="Logo" style={{ width: 24, height: 24 }} />
          SalesCRM
        </div>

        <nav className="crm-nav">
          {navItems.map(({ label, icon: Icon, path }) => (
            <NavLink
              key={path}
              to={path}
              end={path === "/"}
              onClick={() => setOpen(false)}
              className={({ isActive }) => isActive ? "active" : ""}
            >
              <Icon className="crm-nav-icon" />
              {label}
            </NavLink>
          ))}
        </nav>

        {user && (
          <div className="crm-sidebar-user">
            <div className="crm-avatar">{(user.full_name?.[0] ?? user.email?.[0] ?? "U").toUpperCase()}</div>
            <div className="crm-sidebar-user-info">
              <strong>{user.full_name ?? user.email}</strong>
              <span>{user.role ?? "sales_rep"}</span>
            </div>
            <button className="crm-logout-btn" onClick={() => logout(true)} title="Logout">
              Logout
              <LogOut size={15} />
            </button>
          </div>
        )}
      </aside>

      <div className="crm-main">
        <header className="crm-topbar">
          <button onClick={() => setOpen(true)} style={{ background: "none", border: "none", cursor: "pointer" }}>
            <Menu size={20} />
          </button>
          SalesCRM
        </header>
        <main className="crm-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}